<template>
  <fieldset
    :class="_fs_classes"
    :aria-labelledby="hint ? id + '_hint' : undefined"
  >
    <cat-label
      :labelId="id + '_lbl'"
      :fieldset="true"
      :label="label"
      :optional="!mandatory"
      :errors="errors"
      :readonly="readonly"
      :inline="help && !!help.url"
    ></cat-label>
    <cat-help-trigger
      v-if="help && help.url"
      :sourceId="id"
      :url="help.url"
      :title="label"
    />
    <div v-if="help && help.url" class="clearfix"></div>
    <cat-hint :id="id + '_hint'" :text="hint" />
    <cat-help
      v-if="help && help.text"
      :id="id"
      :heading="help.title"
      :text="help.text"
      :aria-describedby="label && id ? id + '_lbl' : null"
    />
    <slot></slot>
    <div class="fields clearfix">
      <div v-for="(item, idx) in items" :key="idx" class="field visual">
        <div class="picker">
          <input
            :id="id + '_' + idx"
            v-model="sel"
            type="radio"
            :name="id"
            :value="item.value"
            :readonly="readonly"
            :data-label="item.text || item.value"
            @click="_onChange"
          />
          <label
            :for="id + '_' + idx"
            data-label-type="card"
            :data-label="item.text || item.value"
            ><span class="picker-icon"><i :class="item.icon" /></span
            ><span class="picker-body">{{ item.text }}</span></label
          >
        </div>
      </div>
    </div>
    <slot name="after-input"></slot>
    <cat-errors :errors="errors" />
  </fieldset>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatErrors from "@/components/catErrors/catErrors.vue";
import CatLabel from "@/components/utilities/cat-label.vue";
import CatHint from "@/components/utilities/hint.vue";
import CatHelp from "@/components/utilities/help.vue";
import CatHelpTrigger from "@/components/catPageTemplate/catHelpTrigger.vue";
export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const displayParams = inject("displayParams", false);

    return {
      resolveTxt,
      displayParams
    };
  },
  components: {
    CatErrors,
    CatLabel,
    CatHelpTrigger,
    CatHint,
    CatHelp
  },
  name: "CatRadioButtonsVisual",
  props: {
    id: [Number, String],
    selected: [String],
    errors: [Array],
    items: [Array],
    row: [Boolean],
    mandatory: [Boolean, String],
    buttons: [Boolean],
    label: [String],
    hint: [String],
    help: [Object],
    readonly: [Boolean],
    vertical: [Boolean]
  },

  data: function () {
    return {
      sel: this.selected ? this.selected : null
    };
  },

  computed: {
    _fs_classes: function () {
      return {
        fieldset: true,
        "cat-radio-set-visual": true,
        invalid: this.errors && this.errors.length > 0,
        required: this.mandatory,
        optional: !this.mandatory,
        "readonly-list": this.readonly,
        stacked: this.vertical
      };
    },
    _findIndex: {
      get() {
        return this.items.findIndex((item) => item.value == this.sel);
      },
      set(v) {
        this.sel = this.items[v] ? this.items[v].value : this.sel;
        this._onChange();
      }
    }
  },

  methods: {
    _onChange: function (event) {
      // console.log("click", event, this.sel, event.target.value);
      // bound attribute isn't updated until after the click.  Need value from event target
      this.$emit("ui-change", {
        event: event,
        id: this.id ? this.id : null,
        value: event.target.value,
        el: this.$el
      });
    }
  }
});
</script>
